import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { AboutKarina } from './components/AboutKarina';
import { BrowServices } from './components/BrowServices';
import { TransitionBlock } from './components/TransitionBlock';
import { KitExplainer } from './components/KitExplainer';
import { Products } from './components/Products';
import { Description } from './components/Description';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { ShopifyDescription } from './components/ShopifyDescription';
import { BrandClosing } from './components/BrandClosing';
import { FloatingAppointmentCTA } from './components/FloatingAppointmentCTA';
import { Footer } from './components/Footer';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
export function App() {
  useEffect(() => {
    document.title = 'Alexa Beauty Brows And Lashes';
    const setMeta = (name: string, content: string) => {
      let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    setMeta('application-name', 'Alexa Beauty Brows And Lashes');
    setMeta('description', 'Alexa Beauty Brows And Lashes — kits premium para pestañas. Organización, elegancia y profesionalismo en un solo kit.');
    let icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!icon) {
      icon = document.createElement('link');
      icon.rel = 'icon';
      document.head.appendChild(icon);
    }
    icon.href = LOGO_URL;
  }, []);
  return <div className="min-h-screen bg-nude-light font-sans selection:bg-gold selection:text-luxury-black" data-id="element-0" data-mp="nvsv37yeytxj">
      <FloatingAppointmentCTA data-id="element-1" data-mp="sudoanf90dch" />

      <main data-id="element-2" data-mp="stc8k5naf2of">
        <Hero data-id="element-3" data-mp="st2kinlsz5ld" />
        <AboutKarina data-id="element-4" data-mp="swqajcs1h9vc" />
        <BrowServices data-id="element-5" data-mp="36hzjfpzb85g" />
        <TransitionBlock data-id="element-6" data-mp="35ox2qy1z4t4" />
        <KitExplainer data-id="element-7" data-mp="34x13f0jn52b" />
        <Products data-id="element-8" data-mp="38kvshhq5xim" />
        <Description data-id="element-9" data-mp="3uct0lbuzo8ws" />
        <Benefits data-id="element-10" data-mp="3udkos1m9b4d1" />
        <Testimonials data-id="element-11" data-mp="3ubzrw5cgz9c0" />
        <CTASection data-id="element-12" data-mp="3ucj91juaptoz" />
        <ShopifyDescription data-id="element-13" data-mp="d4nx5l4r5s4i" />
        <BrandClosing data-id="element-14" data-mp="d4xobc1ja5bs" />
      </main>

      <Footer data-id="element-15" data-mp="d3wd97kipiu2" />
    </div>;
}